(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[66699],{

/***/ 66699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ccpaPrivacyNotice; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/legal/legal.module.scss
var legal_module = __webpack_require__(14777);
var legal_module_default = /*#__PURE__*/__webpack_require__.n(legal_module);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/legal/fallbacks/ccpaPrivacyNoticeFallback.tsx



function CcpaPrivacyNoticeFallback({ domainName , className , mainWrapperClassName  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: `${mainWrapperClassName ?? (legal_module_default()).ccpaMainContainer} ${className ?? ""}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                children: "PRIVACY NOTICE FOR CALIFORNIA RESIDENTS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: mainWrapperClassName ? `timeStyle` : (legal_module_default()).timeStyle,
                children: "Effective Date: September 2023"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "This notice supplements ",
                    domainName,
                    "' comprehensive privacy policy, accessible at",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: `https://${domainName?.toLowerCase()}/privacy-policy`,
                        children: [
                            "https://",
                            domainName,
                            "/privacy-policy"
                        ]
                    }),
                    ', and applies exclusively to individuals residing in the state of California ("California consumers" or "you"). We have prepared this notice in accordance with the California Consumer Privacy Act of 2018 (CCPA), and any terms referenced in the CCPA hold the same meaning when used in this notice.'
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Information We Gather "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'We gather information that directly or indirectly identifies, pertains to, describes, references, or could reasonably be connected with a specific consumer, household, or device ("personal information"). Personal information does not include:'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                className: mainWrapperClassName ? "decimalStyleOnlyLi" : (legal_module_default()).decimalStyleOnlyLi,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Publicly available data from government records."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Deidentified or aggregated consumer data."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Specifically, within the last twelve (12) months, our website has collected the following categories of personal information from consumers:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Category Examples Collected "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                className: mainWrapperClassName ? "decimalStyle" : (legal_module_default()).decimalStyle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Identifiers"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include real names, aliases, postal addresses, unique personal identifiers, online identifiers, Internet Protocol (IP) addresses, email addresses, account names, Social Security numbers, driver's license numbers, passport numbers, or other similar identifiers. YES, we do collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Personal Information Categories Listed in the California Customer Records Statute (Cal. Civ. Code \xa7 1798.80(e))"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include names, signatures, Social Security numbers, physical characteristics, addresses, telephone numbers, passport numbers, driver's license or state identification card numbers, insurance policy numbers, education, employment, employment history, bank account numbers, credit card numbers, debit card numbers, or any other financial information, medical information, or health insurance information. Some personal information in this category may overlap with other categories. YES, we do collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Protected Classification Characteristics Under California or Federal Law"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include age (40 years or older), race, color, ancestry, national origin, citizenship, religion or creed, marital status, medical condition, physical or mental disability, sex (including gender, gender identity, gender expression, pregnancy or childbirth, and related medical conditions), sexual orientation, veteran or military status, and genetic information (including familial genetic information). YES, we do collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Commercial Information"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include records of personal property, products or services purchased, obtained, or considered, or other purchasing or consuming histories or tendencies. YES, we do collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Biometric Information"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include genetic, physiological, behavioral, and biological characteristics or activity patterns used to extract a template or other identifier or identifying information, such as fingerprints, faceprints, voiceprints, iris or retina scans, keystroke, gait, or other physical patterns, and sleep, health, or exercise data. NO, we do not collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Internet or Other Similar Network Activity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include browsing history, search history, and information on a consumer's interaction with a website, application, or advertisement. YES, we do collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Geolocation Data"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include physical locations or movements. YES, we do collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Sensory Data"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include audio, electronic, visual, thermal, olfactory, or similar information. NO, we do not collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Professional or Employment-Related Information"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include current or past job histories or performance evaluations. NO, we do not collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Non-Public Education Information (per the Family Educational Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99))"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include education records directly related to a student maintained by an educational institution or a party acting on its behalf, such as grades, transcripts, class lists, student schedules, student identification codes, student financial information, or student disciplinary records. NO, we do not collect."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Inferences Drawn from Other Personal Information"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Examples include profiles reflecting a person's preferences, characteristics, psychological trends, predispositions, behavior, attitudes, intelligence, abilities, and aptitudes. NO, we do not collect."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Our website obtains the categories of personal information listed above from the following sources:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Directly from you, such as the information you provide when completing forms, purchasing products and services from our network providers, or during the registration process on our website."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Indirectly from you by observing your interactions on our website."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "From our marketing partners, which includes information gathered while providing services to our marketing affiliates."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "From verification service providers, allowing us to update and verify your existing information and offer information about products and services that may interest you."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Use of Personal Information "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We may use, disclose, or sell the personal information we collect for one or more of the following purposes:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To fulfill or meet the reason you provided the information. For instance, if you provide your name and contact information to request a price quote or inquire about our products or services, we will use this personal information to respond to your request. If you share your personal information to purchase a product or service, we will use it for order processing and delivery facilitation."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To provide, support, personalize, and enhance our website, products, and services."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To send you offers for products and services from our marketing affiliates via email."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To establish, maintain, customize, and secure your account with us."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To process your requests, purchases, transactions, and payments and prevent transactional fraud."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To collect demographic information, such as zip codes and gender, to present offers that align with your interests."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To provide support and address your inquiries, including investigation, issue resolution, and response improvement."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To personalize your website experience, we deliver relevant content and product/service offerings, including targeted advertisements, through our website, third-party platforms, and via email or text message (with your consent, as required by law)."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To maintain the security and integrity of our website, products, services, technology assets, and business."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "For testing, research, analysis, and product development, including enhancing and improving our website, products, and services."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To comply with law enforcement requests and legal obligations as mandated by applicable law, court orders, or government regulations."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "As described at the time of collecting your personal information or as otherwise outlined in the CCPA."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "To assess or conduct mergers, divestitures, restructurings, reorganizations, dissolutions, or other sales or transfers of some or all of our assets, whether as a going concern or as part of bankruptcy, liquidation, or a similar process. In such instances, personal information held by us concerning our website users is among the assets transferred."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We will not collect additional categories of personal information or utilize collected personal information for purposes that are substantially different, unrelated, or incompatible without prior notice."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Sharing Personal Information"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We may disclose your personal information to third parties for business purposes or sell it, subject to your right to opt-out of such sales (see Personal Information Sales Opt-Out and Opt-In Rights). When we disclose personal information for business purposes, we enter into contracts specifying the purpose and requiring recipients to keep this information confidential, utilizing it only to fulfill the contract. The CCPA prohibits third parties from acquiring the personal information we hold from reselling it unless you have received explicit notice and an opportunity to opt-out of further sales."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We share your personal information with the following categories of third parties:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Service providers."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Our affiliated entities."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Data aggregators."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Third parties. We share personal information with third parties if you or an authorized representative have granted us authorization to disclose your personal information to them for information regarding products and services provided by us or our third-party marketing affiliates."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Disclosure of Personal Information for Business Purposes"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "In the previous twelve (12) months, ",
                    domainName,
                    " have disclosed the following categories of personal information for business purposes:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Category A:"
                            }),
                            " Identifiers."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Category B:"
                            }),
                            " California Customer Records personal information categories."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Category C:"
                            }),
                            " Protected classification characteristics under California or federal law."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Category D:"
                            }),
                            " Commercial information."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Category F:"
                            }),
                            " Internet or other similar network activity."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Category G:"
                            }),
                            " Geolocation data."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We disclose your personal information for business purposes to the following categories of third parties:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Service providers."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Our affiliated entities."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Data aggregators."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Third parties. We share personal information with third parties if you or an authorized representative have granted us authorization to disclose your personal information to them for information regarding products and services provided by us or our third-party marketing affiliates."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Sales of Personal Information "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "In the past twelve (12) months, ",
                    domainName,
                    " has sold the following categories of personal information:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "A. Identifiers."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "B. California Customer Records personal information categories."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "C. Protected classification characteristics under California or federal law."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "D. Commercial information."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "F. Internet or other similar network activity."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "G. Geolocation data."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We sell your personal information to the following categories of third parties:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Service providers."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Our affiliated entities."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Data aggregators."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Third parties. We share personal information with third parties if you or an authorized representative have granted us authorization to disclose your personal information to them for information regarding products and services provided by us or our third-party marketing affiliates."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Your Rights and Choices "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "The CCPA grants California consumers specific rights concerning their personal information. This section outlines your CCPA rights and explains how to exercise them."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Access to Specific Information and Data Portability Rights"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You have the right to request that we disclose particular information to you about our collection and utilization of your personal information during the past 12 months. Upon receiving and verifying your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will provide you with:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "The categories of personal information about you that we collected."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "The sources of personal information collection."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Our business or commercial purpose for collecting or selling the personal information."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "The categories of third parties with whom we shared your personal information."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "The specific pieces of personal information collected about you (also known as a data portability request)."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "If we sold or disclosed your personal information for a business purpose, we would provide two separate lists specifying sales, outlining the personal information categories each category of recipient bought, and disclosures for a business purpose, detailing the personal information categories each category of recipient obtained."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Deletion Request Rights"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You have the right to request that we delete any of your personal information collected from you and retained, subject to certain exceptions. Once we receive and verify your verifiable consumer request (see Exercising Access, Data Portability, and Deletion Rights), we will delete (and instruct our service providers to delete) your personal information from our records unless an exception applies."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We may decline your deletion request if retaining the information is necessary to:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Complete the transaction for which we collected the personal information, deliver a product or service you requested, take actions reasonably anticipated within the context of our ongoing business relationship with you, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, or perform our contract with you."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Detect security incidents, protect against malicious, deceptive, fraudulent, or unlawful activities, or prosecute those responsible for such actions."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Debug products to identify and rectify errors impairing their intended functionality."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Exercise free speech, safeguard another consumer's rights to exercise their free speech rights or fulfill another right established by law."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Comply with the California Electronic Communications Privacy Act (Cal. Penal Code \xa7 1546 et seq.)."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest, adhering to all applicable ethics and privacy laws when deleting the information would likely prevent or significantly impair the research's accomplishment, provided you previously granted informed consent."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Enable solely internal uses, aligning with consumer expectations based on your relationship with us."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Comply with a legal obligation."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Pursue other internal and lawful purposes for that information compatible with the context in which you initially provided it."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Exercising Access, Data Portability and Deletion Rights"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "To exercise the rights of access, data portability, and deletion described above, please submit a verifiable consumer request by emailing our data protection officer at the following email address",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: `mailto:info@${domainName?.toLowerCase()}`,
                        children: [
                            "info@",
                            domainName
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Only you or an authorized representative acting on your behalf may make a verifiable consumer request. You may also make a verifiable consumer request on behalf of your minor child."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "You may only make two verifiable consumer requests for access or data portability within a 12-month period. The verifiable consumer request must:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: "Include enough information to allow us to verify that you are the person about whom we collected personal information or an authorized representative, such as providing details sufficient to enable us to comprehend, evaluate, and address the request properly."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We cannot respond to your request or provide you with personal information unless we can verify your identity or authority to make the request and confirm that the personal information relates to you."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Creating an account with us is not mandatory to make a verifiable consumer request."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We will only utilize personal information provided in a verifiable consumer request to verify the requestor's identity or authority to make the request."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "For instructions on exercising opt-out rights regarding personal information sales, see Personal Information Sales Opt-Out and Opt-In Rights."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Response Timing and Format"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We aim to respond to a verifiable consumer request within 45 days of receiving it. If we need more time (up to 90 days), we will notify you of the reason and extension period in writing."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "If you possess an account with us, we will send our written response to that account. If you do not have an account with us, we will provide our written response via mail or electronically, at your choice."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Any information disclosed will cover only the 12-month period preceding the receipt of the verifiable consumer request. The response will also clarify any reasons for our inability to comply with a request, if applicable. For data portability requests, we will select a format that makes your personal information readily usable and transferrable, allowing you to transmit it from one entity to another entity without hindrance."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We do not impose a fee for processing or responding to verifiable consumer requests unless they are excessive, repetitive, or clearly unfounded. If we determine a fee is warranted, we will explain why and provide a cost estimate before fulfilling your request."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Personal Information Sales Opt-Out and Opt-In Rights"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: 'If you are at least 16 years old, you have the right to instruct us not to sell your personal information at any time (the "opt-out right"). We do not sell personal information belonging to consumers we know are under 16 years of age. Consumers who opt-in to personal information sales can opt-out of future sales at any moment.'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "To exercise the opt-out right, you (or your authorized representative) can submit a request to us by emailing our data protection officer at the following email address:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: `mailto:info@${domainName?.toLowerCase()}`,
                        children: [
                            "info@",
                            domainName
                        ]
                    }),
                    " ",
                    "or by clicking the following link: Do Not Sell My Personal Information."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Once you make an opt-out request, we will wait at least twelve (12) months before requesting your authorization for personal information sales again. However, you may change your mind and opt back into personal information sales at any time by contacting us at the following email address:",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: `mailto:info@${domainName?.toLowerCase()}`,
                        children: [
                            "info@",
                            domainName
                        ]
                    }),
                    ".",
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Creating an account with us is not necessary to exercise your opt-out rights. We will only use personal information provided in an opt-out request to review and comply with the request."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Non-Discrimination"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We will not discriminate against you for exercising any of your CCPA rights. Unless permitted by the CCPA, we will not:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Refuse to provide you with goods or services."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Charge you different prices or rates for goods or services, including by granting discounts or other benefits or imposing penalties."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Offer you a different level or quality of goods or services."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: "Suggest that you might receive a different price or rate for goods or services or a different level or quality of goods or services."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Other California Privacy Rights"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    'California\'s "Shine the Light" law (Civil Code Section \xa7 1798.83) permits users of our website who are California residents to request specific information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please send an email to',
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: `mailto:info@${domainName?.toLowerCase()}`,
                        children: [
                            "info@",
                            domainName
                        ]
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Changes to Our Privacy Notice"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "We retain the right to revise this privacy notice at our discretion and at any time. When we make changes to this privacy notice, we will publish the updated notice on our website and adjust the notice's effective date accordingly. Your continued use of our website following the posting of changes implies your acceptance of those changes."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Contact Information"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "If you have any questions or comments about this notice, how",
                    domainName,
                    " collects and uses your information, as described here and in the Privacy Policy, your options and rights regarding such use, or if you wish to exercise your rights under California law, please do not hesitate to contact us at:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                    children: [
                        domainName,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "2810 N Church St #56440 ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Wilmington, DE 19802",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Email:",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            href: `mailto:info@${domainName?.toLowerCase()}`,
                            children: [
                                "info@",
                                domainName
                            ]
                        }),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "Phone Number:",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "tel:18888965558",
                            children: "+1 (888) 896-5558"
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var ccpaPrivacyNoticeFallback = (CcpaPrivacyNoticeFallback);

;// CONCATENATED MODULE: ./src/components/shared/legal/ccpaPrivacyNotice.tsx





function CcpaPrivacyNotice({ domainNameAsProp , className , mainWrapperClassName  }) {
    const { domain: { textBlocks , name: actualDomainName , niceName  } , category ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const categoryName = category?.name;
    const domainName = niceName ?? actualDomainName ?? domainNameAsProp;
    const domainCcpaPrivacyNotice = textBlocks?.find((textBlock)=>textBlock.position === "custom-domain-ccpa-privacy-notice")?.text;
    const categoryCcpaPrivacyNotice = textBlocks?.find((textBlock)=>textBlock.position === "custom-category-ccpa-privacy-notice")?.text;
    return domainCcpaPrivacyNotice || categoryCcpaPrivacyNotice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: `${mainWrapperClassName ?? (legal_module_default()).ccpaMainContainer} ${className ?? ""}`,
        dangerouslySetInnerHTML: {
            __html: (domainCcpaPrivacyNotice ?? categoryCcpaPrivacyNotice)?.replace(/{domainName}/g, domainName)?.replace(/{categoryName}/g, categoryName ?? "")?.replace(/{mailInfo}/g, domainName.toLowerCase()) ?? ""
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ccpaPrivacyNoticeFallback, {
        domainName: domainName,
        className: className,
        mainWrapperClassName: mainWrapperClassName
    });
}
/* harmony default export */ var ccpaPrivacyNotice = (CcpaPrivacyNotice);


/***/ }),

/***/ 14777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","legal":"legal_legal__qUt4s","ccpaMainContainer":"legal_ccpaMainContainer__EgCgv","decimalStyleOnlyLi":"legal_decimalStyleOnlyLi__qBRw_","decimalStyle":"legal_decimalStyle__ostDo","alphaStyle":"legal_alphaStyle__B5bJA","timeStyle":"legal_timeStyle__bx7dw"};

/***/ })

}]);